import { render, staticRenderFns } from "./questionnaireMatrix.vue?vue&type=template&id=52a09891&scoped=true"
import script from "./questionnaireMatrix.vue?vue&type=script&lang=js"
export * from "./questionnaireMatrix.vue?vue&type=script&lang=js"
import style0 from "./questionnaireMatrix.vue?vue&type=style&index=0&id=52a09891&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a09891",
  null
  
)

export default component.exports